module.exports = __webpack_public_path__ + "img/logo.76c9d25b.svg";